module.exports = __webpack_public_path__ + "img/SKMJ_net2.3ac7cfcc.png";